
export default "/assets/magnifying-glass-micro.a2dac8a5.svg"